import React from 'react';
import { useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';

import 'Components/SecondaryNavBar/SecondaryNavBar.scss';
import { useSelector } from "react-redux";
import { emptyObject } from "../../utils/formUtils";

export default function SecondaryNavBar({ activePage }) {

    const CONF = window?.confPub;
    const ROUTES_PAGES = CONF.ROUTES.PAGES;

    const navigate = useNavigate();

    const {
        tablePersonne,
        detailPersonne,
        contratsBeneficiaires,
    } = useSelector(state => ({
        ...state.gestionContratReducer,
    }))

    const recherchePage = 'recherche';
    const fichePersonne = 'fichePersonne';
    const ficheContratPage = 'ficheContrat';
    const formulaires = "formulaires";
    const indemnisation = "indemnisation";
    const indemnisationFormulaire = "indemnisation-formulaire";
    const remboursements = "remboursements";

    const linkArray = [];

    if (tablePersonne) {
        linkArray.push({
            isLink: activePage !== recherchePage,
            url: ROUTES_PAGES?.RECHERCHE_PERSONNE,
            label: 'RECHERCHE'
        });
    }

    if (!emptyObject(detailPersonne)) {

        const labelPersonne = detailPersonne?.nom && detailPersonne?.prenom ? `${ detailPersonne?.nom } ${ detailPersonne?.prenom }` : 'INFORMATIONS PERSONNELLES';

        linkArray.push({
            isLink: activePage !== fichePersonne,
            url: ROUTES_PAGES?.FICHE_PERSONNE,
            label: "INFORMATIONS PERSONNELLES"
        });
    }

    if (contratsBeneficiaires.length > 0) {
        linkArray.push({
            isLink: activePage !== ficheContratPage,
            url: ROUTES_PAGES?.FICHE_CONTRAT,
            label: `CONTRAT`
        });
    }

    if (formulaires === activePage) {
        linkArray.push({
            isLink: formulaires !== activePage,
            url: ROUTES_PAGES?.FICHE_CONTRAT,
            label: `FORMULAIRES`
        });
    }

    if (indemnisation === activePage || indemnisationFormulaire === activePage) {
        linkArray.push({
            isLink: indemnisation !== activePage,
            url: ROUTES_PAGES?.DEMANDE_INDEMNISATION?.LISTE_INDEMNISATION,
            label: `DEMANDE D'INDEMNISATION`
        });
    }

    if (indemnisationFormulaire === activePage) {
        linkArray.push({
            isLink: indemnisationFormulaire !== activePage,
            url: ROUTES_PAGES?.DEMANDE_INDEMNISATION?.FORMULAIRE_INDEMNISATION,
            label: `FORMULAIRE D'INDEMNISATION`
        });
    }

    if (remboursements === activePage) {
        linkArray.push({
            isLink: remboursements !== activePage,
            url: ROUTES_PAGES?.DEMANDE_INDEMNISATION?.REMBOURSEMENTS,
            label: `REMBOURSEMENTS`
        });
    }

    return (
        <section id='secondary-nav-bar' className='secondary-navbar'>
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb">

                    { linkArray?.map(link => (
                        <li key={ uuidv4() } className={ `breadcrumb-item  ${ !link?.isLink ? "active" : "" }` }
                            aria-current={ `${ !link?.isLink && "page" }` }
                        >
                            { link?.isLink ?
                                <a
                                    onClick={ () => navigate(link?.url) }
                                    key={ uuidv4() }
                                    href="#">
                                    { link?.label }
                                </a>
                                :
                                <span className='bold'>
                                    { link?.label }
                                </span>
                            }
                        </li>
                    )) }
                </ol>
            </nav>
        </section>
    )
}